import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import SyncIcon from "@mui/icons-material/Sync";
import {
  GridRowModes,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";

function EditToolbar(props) {
  const { setTeachersData, setRowModesModel, handleAddUpdateTeacher, isAdmin } = props;
  const navigate = useNavigate();

  const handleAddClick = () => {
    handleAddUpdateTeacher(0);
  };

  const handleRefresh = () => {
    navigate(0);
  };

  return (
    <GridToolbarContainer>
      <Button
        color="primary"
        startIcon={<AddIcon />}
        onClick={handleAddClick}
        disabled={!isAdmin}
      >
        Neu
      </Button>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
      <GridToolbarExport
        csvOptions={{
          fileName: "Lehrkräfte",
          delimiter: ";",
          utf8WithBom: true,
        }}
      />
      <GridToolbarQuickFilter />
      <Button color="primary" startIcon={<SyncIcon />} onClick={handleRefresh}>
        Refresh
      </Button>
    </GridToolbarContainer>
  );
}

EditToolbar.propTypes = {
  setRowModesModel: PropTypes.func.isRequired,
  setTeachersData: PropTypes.func.isRequired,
  handleAddUpdateTeacher: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool,
};

export default EditToolbar;